import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './../../app.component';

import { LegalRoutingModule } from './legal-routing.module';

// Modules
import { SharedModule } from '@modules/shared.module';

/// Components
import { AuthorizationComponent } from './authorization/authorization.component';
import { PoliticsComponent } from './politics/politics.component';
import { TermsComponent } from './terms/terms.component';
import { ServicePoliticsComponent } from './service-politics/service-politics.component';
import { CookiesPoliticsComponent } from './cookies-politics/cookies-politics.component';

@NgModule({
  declarations: [
    AuthorizationComponent,
    PoliticsComponent,
    TermsComponent,
    ServicePoliticsComponent,
    CookiesPoliticsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LegalRoutingModule,
  ],
  bootstrap: [AppComponent]
})
export class LegalModule { }